import {
  Container,
  Row,
  Col,
  Button,
  Stack,
  Heading,
  Text
} from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from '../../components/Icon'
import * as S from './styled'

const SectionHero = () => (
  <S.Section>
    <Container>
      <Col size={{ giga: 10 }} offset={{ giga: 1 }}>
        <S.Article>
          <Row>
            <Col size={{ giga: 7 }}>
              <Stack spacing="giga">
                <S.WrapperLogo>
                  <Icon name="logo" />
                </S.WrapperLogo>

                <Heading size="peta" noMargin>
                  O programa de recompensas perfeito para quem ama vantagens!
                </Heading>

                <Text size="mega" noMargin>
                  Ganhar descontos exclusivos, ter lugar reservado em eventos,
                  cursos, workshops e outros benefícios sem pagar nada, parece
                  uma boa ideia? Então vem com a gente…
                </Text>
                <S.WrapperButton>
                  <Button as="a" href="/fidelidade/participar">
                    Eu quero!
                  </Button>
                </S.WrapperButton>
              </Stack>
            </Col>
          </Row>
        </S.Article>
      </Col>
    </Container>
  </S.Section>
)

export default SectionHero
